import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { canEditPetition, Loading, petitionSlugCanonicalRedirect } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'add-endorsement',
		path: '/p/:slug/dashboard/endorsements/add',
		beforeServerRender: async (context) => {
			await petitionSlugCanonicalRedirect(context);
		},
		component: loadable(
			async () => import(/* webpackChunkName: "pages/starterDashboardEndorsements" */ './entryPoint/add'),
			{
				exportName: 'AddEndorsement',
				fallback: Loading,
			},
		),
		frame: true,
		restrictedAccess: {
			authOnly: true,
			role: ['staff', canEditPetition('slug')],
		},
		ssr: {
			enabled: true,
			seo: false,
		},
	},
	{
		id: 'edit-endorsement',
		path: '/p/:slug/dashboard/endorsements/edit/:endorsementId',
		beforeServerRender: async (context) => {
			await petitionSlugCanonicalRedirect(context);
		},
		component: loadable(
			async () => import(/* webpackChunkName: "pages/starterDashboardEndorsements" */ './entryPoint/edit'),
			{
				exportName: 'EditEndorsement',
				fallback: Loading,
			},
		),
		frame: true,
		restrictedAccess: {
			authOnly: true,
			role: ['staff', canEditPetition('slug')],
		},
		ssr: {
			enabled: true,
			seo: false,
		},
	},
];
